module.exports = {
  FlashObject: {
    PluginName: "Objeto Flash",
    config: "Configuración",
  },
};
